/*
eslint
no-multi-spaces: ["error", {exceptions: {"VariableDeclarator": true}}]
padded-blocks: ["error", {"classes": "always"}]
max-len: ["error", 80]
*/
'use strict'

module.exports = isObject

function isObject (val) {
  return !(val == null || typeof val !== 'object' || Array.isArray(val))
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/is.object/index.js
// module id = ZR6r
// module chunks = 0